<template>
  <div>

    <section>
      <v-parallax src="/assets/06_caprice_butterfly.jpg" height="550">
        <v-layout column align-center justify-center fill-height class="white--text">
          <div><v-img src="/assets/03_yukari_reverse.png" alt="yukari_reverse" width="160" contain /></div>
          <h1 class="white--text mb-2 display-1 text-xs-center">MistDewing</h1>
          <div class="subheading mb-3 text-xs-center">COMPOSER / SONGWRITER / GUITARIST</div>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container grid-list-xs>
        <v-layout column wrap class="my-5" justify-center align-center>
          <h2 class="headline">Discography</h2>
          <span class="subheading">Vocaloid songs</span>
        </v-layout>
        <v-container grid-list-xl>
          <v-layout wrap>
            <v-flex xs12 sm6 md6 v-for="item in discography" :key="item.index">

              <v-card class="fill-height">
                <v-img
                  :src="item.imgSrc"
                  class="white--text align-end"
                  style="cursor: pointer;"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="300px"
                  @click="playMovie(item)"
                >
                  <v-card-title v-text="item.songTitle"></v-card-title>
                </v-img>
                <v-card-subtitle v-html="item.discription"></v-card-subtitle>
                <v-spacer class="action-above-space" />
                <v-card-actions class="action-position">
                  <v-layout justify-space-between fill-height align-center class="pr-3 py-1">
                    <v-card-subtitle>Uploaded: {{item.date}}</v-card-subtitle>
                    <div>
                      <v-btn icon large @click="openUrl(item.hrefYoutube)">
                        <v-icon large>mdi-youtube</v-icon>
                      </v-btn>
                      <v-btn icon large @click="openUrl(item.hrefNico)">
                        <v-icon large>mdi-movie-roll</v-icon>
                      </v-btn>
                    </div>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-container>
    </section>

    <v-dialog v-model="dlgPlay" v-if="selectedItem" width="768" content-class="dialog-content">
      <iframe width="768" height="432" :src="selectedItem.srcYoutube" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </v-dialog>

    <section>
      <v-parallax src="/assets/guitar.jpg" height="512" />
    </section>

  </div>
</template>

<script>
import discography from '@/discography'
export default {
  data () {
    return {
      title: 'MistDewing',
      discography,
      dlgPlay: false,
      selectedItem: null
    }
  },
  watch: {
    dlgPlay (val) {
      if (!val) this.selectedItem = null
    }
  },
  mounted () {},
  methods: {
    playMovie (item) {
      // item.dialog = true
      this.selectedItem = item
      this.dlgPlay = true
    },
    openUrl (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss">
  .dialog-content {
    height: 432px;
    overflow-y: visible !important;
  }
  .action-position {
    width: 100%;
    position: absolute;
    bottom: 0px;
    right: 0px;
  }
  .action-above-space {
    height: 60px;
  }
</style>
